module.exports = __webpack_public_path__ + "img/italy-blood-diseases-male.c4866f66.png";